export default __webpack_public_path__ + "static/media/register.04224fdd.svg";